import ReactGA from "react-ga4";

const isProduction = import.meta.env.VITE_APP_ENV === "production";

const gaPageView = (page: string, title?: string) => {
  if (import.meta.env.VITE_GA4_MEASUREMENT_ID && isProduction) {
    // we only want to track page views in production
    ReactGA.initialize(import.meta.env.VITE_GA4_MEASUREMENT_ID);
    ReactGA.send({ hitType: "pageview", page: page, title: title });
  }
};

const gaEvent = (category: string, action: string, label?: string, value?: number, nonInteraction?: boolean) => {
  if (import.meta.env.VITE_GA4_MEASUREMENT_ID && isProduction) {
    // we only want to track events in production
    ReactGA.event({
      category: category,
      action: action,
      label: label,
      value: value,
      nonInteraction: nonInteraction,
    });
  }
};

export { gaPageView, gaEvent };
